export const INSIGHTS = [
  {
    slug: "navigating-market-volatility-hni-playbook",
    title: "Navigating Market Volatility: An HNI Playbook",
    excerpt:
      "Volatility is not a risk to be eliminated — it is a feature to be priced. A practical framework HNI investors can use to stay invested without losing sleep.",
    category: "Wealth Strategy",
    readTime: "6 min read",
    date: "November 2025",
    content: [
      "Volatility is not a risk to be eliminated — it is a feature to be priced. The investors who compound the most over multi-decade horizons are not the ones who avoided drawdowns; they are the ones who stayed invested through them.",
      "For HNI portfolios, the playbook starts with structure. A goal-linked allocation across equity, fixed income, alternatives and cash creates the elasticity required to absorb shocks without forcing a sale at the bottom of a cycle.",
      "Second, behavioural friction matters more than forecasting. Pre-committed rebalancing rules, automated SIPs into volatility, and a written investment policy statement (IPS) consistently outperform discretionary reaction.",
      "Finally, taxation is a silent return. Strategic harvesting of long-term capital gains, considered switching between direct and regular plans, and use of MLDs / Cat III structures all add up across cycles.",
    ],
  },
  {
    slug: "nri-investing-in-india-2026-fema-guide",
    title: "NRI Investing in India: A 2026 FEMA & Tax Guide",
    excerpt:
      "The complete framework for NRIs to invest into Indian markets — accounts, instruments, repatriation, DTAA, and estate planning.",
    category: "NRI Services",
    readTime: "9 min read",
    date: "October 2025",
    content: [
      "Indian capital markets remain among the most attractive opportunity sets for non-resident Indians — but participation requires careful navigation of FEMA, RBI and income-tax frameworks.",
      "The starting point is account architecture: NRE for repatriable foreign earnings, NRO for India-sourced income, and FCNR(B) for fixed-income in foreign currency. Each maps to a distinct tax and remittance profile.",
      "For listed equity, PIS-enabled NRE/NRO accounts allow direct stock investing. Mutual funds can be held via KYC-compliant NRE/NRO routes. Several AMCs restrict subscriptions for US/Canada-resident NRIs — this should be confirmed up front.",
      "DTAA between India and the country of residence (UAE, Singapore, UK, US) is the single most important document for tax efficiency on capital gains, dividends and interest. Form 10F, TRC and PAN linkage are mandatory.",
      "Finally, every NRI portfolio should include an estate plan with an Indian Will and clearly nominated holdings — particularly for jointly-held property and demat accounts.",
    ],
  },
  {
    slug: "pms-vs-aif-vs-mutual-funds-decision-framework",
    title: "PMS vs AIF vs Mutual Funds: A Decision Framework",
    excerpt:
      "When does a ₹50 lakh PMS make sense over a mutual fund? Where do AIFs fit? A clear, side-by-side comparison.",
    category: "Investment Products",
    readTime: "7 min read",
    date: "September 2025",
    content: [
      "Mutual funds, PMS and AIFs are often presented as substitutes — they are not. They sit on different points of the capital, customisation and complexity curve.",
      "Mutual funds are the most efficient vehicle for diversified, daily-liquid exposure with strong investor protection and low minimums. They should anchor most portfolios.",
      "PMS is best understood as a concentrated, transparent equity portfolio with the investor as direct beneficial owner of the stocks. It suits investors with a ₹50L+ allocation comfortable with active concentration.",
      "AIFs span private credit, long-short, real estate and venture. Cat II is largely private credit; Cat III is long-short equity and arbitrage. Liquidity is gated, fees are layered, and suitability needs careful underwriting.",
      "The right answer is rarely 'either-or' — most HNI portfolios use all three with mandates calibrated to specific goals.",
    ],
  },
  {
    slug: "succession-planning-without-disputes",
    title: "Succession Planning Without Disputes",
    excerpt:
      "Wills, trusts, family charters — the three pillars of a wealth transition that survives generations and lawsuits.",
    category: "Estate Planning",
    readTime: "5 min read",
    date: "August 2025",
    content: [
      "Wealth that took decades to build can fragment in months without a clear succession framework. The cost is rarely just financial — it is also relational.",
      "A registered Will is the minimum baseline. It removes ambiguity, names executors, and reduces the probate timeline materially.",
      "For families with operating businesses or assets across jurisdictions, a private family trust adds protection from creditor risk, smoothens cross-border transitions, and enables structured distributions.",
      "The third pillar is governance: a written family charter that codifies values, decision rights and conflict resolution. It is the document that prevents disputes long before they reach a courtroom.",
    ],
  },
];

export const findInsight = (slug) => INSIGHTS.find((p) => p.slug === slug);
